(function(window, document) {
  'use strict';

  const ENDPOINT = 'https://store-rsv-system-project.web.app/publicGetReservationStatus';
  const COOLDOWN_MS = 12000;
  const ERROR_COOLDOWN_MS = 5000;
  const container = document.getElementById('rsv-submitted-status-root');
  if (!container) return;

  const isEnglish = container.getAttribute('data-locale') === 'en'
    || window.location.pathname.startsWith('/en/');
  const statusPagePath = isEnglish ? '/en/pages/rsv-status' : '/pages/rsv-status';

  const i18n = isEnglish ? {
    lead: [
      'We recommend saving this page URL so you can check it again later.'
    ],
    statusDescriptions: {
      confirmed: {
        heading: 'About your reservation status',
        body: [
          'Your reservation has been confirmed.',
          'We look forward to welcoming you on the day of your visit.',
          'Please take care on your way here.'
        ]
      },
      tentative: {
        heading: 'About your reservation status',
        body: [
          'You can check the latest status of your reservation on this page.',
          'Our staff is currently reviewing the details of your request.',
          'Your reservation has not been confirmed yet.',
          'Please wait a little while, then check this page again.'
        ]
      },
      pending: {
        heading: 'About your reservation status',
        body: [
          'You can check the latest status of your reservation on this page.',
          'Our staff is currently reviewing your request based on the details you submitted.',
          'Your reservation has not been confirmed yet.',
          'It may take a little time before your reservation is confirmed, so please wait a little while and check this page again.'
        ]
      }
    },
    copy: 'Copy this confirmation URL',
    copied: 'Copied',
    loading: 'Checking reservation status...',
    unavailable: 'We could not show reservation details from this URL.',
    fallbackLink: 'Check reservation status',
    changeCancel: 'Change / cancel reservation here',
    statusTitle: 'Reservation status',
    confirmedDetailsTitle: 'Confirmed reservation details',
    requestDetailsTitle: 'Reservation request details',
    notConfirmedNote: 'Your reservation is not confirmed yet. Once confirmed, this page will show "Confirmed".',
    transferNote: 'The requested store and confirmed store are different.',
    checkLatest: 'Check latest reservation status',
    checking: 'Checking...',
    wait: 'Please wait before checking again',
    lastChecked: 'Last checked',
    checkError: 'We could not check the latest reservation status. Please try again later.',
    labels: {
      reservationId: 'Reservation ID',
      name: 'Name',
      people: 'Guests',
      requestedStore: 'Requested store',
      confirmedStore: 'Confirmed store',
      first: 'First preferred date/time',
      second: 'Second preferred date/time',
      confirmedAt: 'Confirmed date/time',
      menu: 'Menu',
      option: 'Options'
    },
    notSelected: 'Not selected',
    statuses: {
      confirmed: 'Confirmed',
      tentative: 'Tentative',
      pending: 'Under review',
      requires_action: 'Needs attention',
      unknown: 'Checking status',
      unavailable: 'Unavailable',
      cancelled: 'Cancelled',
      transferred: 'Store changed'
    }
  } : {
    lead: [
      'また後ほど確認できるよう、このページのURLを保存しておくことをおすすめします。'
    ],
    statusDescriptions: {
      confirmed: {
        heading: 'ご予約状況について',
        body: [
          'お客様のご予約は確定しました。',
          '当日はどうぞお気をつけてお越しください。',
          '当日お目にかかれることを、楽しみにお待ちしております。'
        ]
      },
      tentative: {
        heading: 'ご予約状況について',
        body: [
          'このページでは、お客様の最新のご予約状況をご確認いただけます。',
          'ただいま、スタッフがご希望いただいた内容を確認しております。',
          'ご予約はまだ確定しておりません。',
          '少し時間をおいてから、あらためてこのページをご確認ください。'
        ]
      },
      pending: {
        heading: 'ご予約状況について',
        body: [
          'このページでは、お客様の最新のご予約状況をご確認いただけます。',
          'ただいま、スタッフがご希望の内容をもとに確認を進めております。',
          'ご予約はまだ確定しておりません。',
          '確定まで少しお待たせしてしまう場合がありますが、少し時間をおいてから、このページをご確認いただけますと幸いです。'
        ]
      }
    },
    copy: 'この確認URLをコピー',
    copied: 'コピーしました',
    loading: '予約状況を確認しています...',
    unavailable: 'このURLから予約情報を表示できませんでした。',
    fallbackLink: '予約状況を確認する',
    changeCancel: '変更/キャンセルが必要な場合はこちら',
    statusTitle: '予約状況',
    confirmedDetailsTitle: '予約確定の内容',
    requestDetailsTitle: '予約申し込み情報',
    notConfirmedNote: 'まだ予約確定前です。確定し次第、このページに「予約確定」と表示されます。',
    transferNote: '申込店舗と確定店舗が異なります。',
    checkLatest: '最新の予約状況を確認する',
    checking: '確認しています...',
    wait: '少し時間をおいて再度ご確認ください',
    lastChecked: '最終確認',
    checkError: '最新の状況を確認できませんでした。少し時間をおいて、もう一度お試しください。',
    labels: {
      reservationId: '予約ID',
      name: '予約者名',
      people: '人数',
      requestedStore: '申込店舗',
      confirmedStore: '確定店舗',
      first: '第一希望日時',
      second: '第二希望日時',
      confirmedAt: '確定日時',
      menu: 'メニュー',
      option: 'オプション'
    },
    notSelected: '選択なし',
    statuses: {
      confirmed: '予約確定',
      tentative: '仮予約中',
      pending: '確認中',
      requires_action: '要対応',
      unknown: '確認中',
      unavailable: '予約不可',
      cancelled: 'キャンセル済み',
      transferred: '店舗振替'
    }
  };

  const params = new URLSearchParams(window.location.search);
  const rid = (params.get('rid') || params.get('reservationId') || '').trim();
  const token = (params.get('token') || '').trim();
  const escapeHtml = (v) => String(v == null ? '' : v)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
  const renderTextPart = (part) => {
    if (part && typeof part === 'object' && part.href && part.text) {
      return `<a href="${escapeHtml(part.href)}">${escapeHtml(part.text)}</a>`;
    }
    return escapeHtml(part);
  };
  const renderParagraph = (parts) => {
    const normalized = Array.isArray(parts) ? parts : [parts];
    return `<p>${normalized.map(renderTextPart).join('')}</p>`;
  };
  const hasValue = (v) => typeof v === 'string' ? v.trim() !== '' : v != null && v !== '';
  const safe = (v, f='-') => hasValue(v) ? v : f;
  const pickFirst = (...values) => values.find(hasValue);
  const normalizeStore = (value) => String(value || '').trim().toLowerCase().replace(/\s+/g, '');
  const formatJst = (value) => {
    if (!hasValue(value)) return '';
    const text = String(value);
    const date = new Date(text);
    if (Number.isNaN(date.getTime())) return text;
    return date.toLocaleString(isEnglish ? 'en-US' : 'ja-JP', {
      timeZone: 'Asia/Tokyo',
      year: 'numeric',
      month: isEnglish ? 'short' : '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  };

  let currentReservation = null;
  let currentStatus = '';
  let isFetching = false;
  let cooldownTimer = null;
  let lastCheckedAt = null;
  let latestError = '';

  function renderShell(bodyHtml) {
    const currentUrl = window.location.href;
    container.removeAttribute('data-loading');
    container.innerHTML = `
      <section class="rsv-submitted-status" aria-live="polite">
        <div id="rsv-submitted-status-body">${bodyHtml}</div>
        <div class="rsv-submitted-status__intro">
          ${i18n.lead.map(renderParagraph).join('')}
        </div>
        <div class="rsv-submitted-status__copy">
          <div class="rsv-submitted-status__url-box" aria-label="${escapeHtml(i18n.copy)}">${escapeHtml(currentUrl)}</div>
          <button type="button" class="btn" id="rsv-submitted-copy-url">${escapeHtml(i18n.copy)}</button>
          <span id="rsv-submitted-copy-result" class="rsv-submitted-status__copy-result" role="status"></span>
        </div>
        <div id="rsv-submitted-confirmed-guide"></div>
      </section>
    `;
    attachCopyHandler();
  }

  function attachCopyHandler() {
    const copyBtn = document.getElementById('rsv-submitted-copy-url');
    const copyResult = document.getElementById('rsv-submitted-copy-result');
    if (!copyBtn) return;
    copyBtn.addEventListener('click', async function() {
      try {
        await navigator.clipboard.writeText(window.location.href);
        copyResult.textContent = i18n.copied;
      } catch (e) {
        const textarea = document.createElement('textarea');
        textarea.value = window.location.href;
        textarea.setAttribute('readonly', 'readonly');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        copyResult.textContent = i18n.copied;
      }
    });
  }

  function getBody() {
    return document.getElementById('rsv-submitted-status-body');
  }

  function renderFallback(message) {
    renderShell(`
      <div class="rsv-submitted-status__fallback">
        <p>${escapeHtml(message || i18n.unavailable)}</p>
        <a class="btn" href="${escapeHtml(statusPagePath)}">${escapeHtml(i18n.fallbackLink)}</a>
      </div>
    `);
  }

  function normalizeReservationResponse(json) {
    if (!json || json.success === false) return null;
    if (json.reservation) return json.reservation;
    if (json.data && json.data.reservation) return json.data.reservation;
    if (Array.isArray(json.results) && json.results[0]) return json.results[0];
    if (json.result && typeof json.result === 'object') return json.result;
    return null;
  }

  function resolveDisplayStatus(reservation) {
    const adminStatus = String(reservation.adminStatus || reservation.resolvedAdminStatus || '');
    const statusText = `${reservation.displayStatus || ''} ${reservation.displayStatusLabel || ''} ${adminStatus} ${reservation.status || ''} ${reservation.operationStatusText || ''}`;
    if (/当日対応注意/.test(statusText)) return 'confirmed';
    if (hasValue(reservation.displayStatus)) return String(reservation.displayStatus);
    if (!statusText.trim()) return 'unknown';
    if (reservation.archived === true || /cancel|cancell?ed|キャンセル|取消/.test(statusText)) return 'cancelled';
    if (/要対応|needs_action|in_progress/.test(statusText)) return 'requires_action';
    if (/予約不可|不可|unavailable/.test(statusText)) return 'unavailable';
    if (/未確定|未確認|仮|tentative|pending/.test(statusText)) return 'pending';
    if (/確定済み|confirmed/.test(statusText)) return 'confirmed';
    return 'unknown';
  }

  function statusLabel(reservation, status) {
    const statusText = `${reservation.displayStatus || ''} ${reservation.displayStatusLabel || ''} ${reservation.adminStatus || ''} ${reservation.resolvedAdminStatus || ''} ${reservation.status || ''} ${reservation.operationStatusText || ''}`;
    if (!isEnglish && /当日対応注意/.test(statusText)) return i18n.statuses.confirmed;
    if (!isEnglish && hasValue(reservation.displayStatusLabel)) return String(reservation.displayStatusLabel);
    return i18n.statuses[status] || i18n.statuses.pending;
  }

  function statusDescriptionKey(status, label) {
    const text = `${status || ''} ${label || ''}`.toLowerCase();
    if (/仮|tentative|temporary/.test(text)) return 'tentative';
    if (/確認中|未確定|未確認|under review|under_review|pending/.test(text)) return 'pending';
    if (/予約確定|確定済み|reservation confirmed|reservation_confirmed|confirmed/.test(text)) return 'confirmed';
    return 'pending';
  }

  function renderStatusDescription(status, label) {
    const section = i18n.statusDescriptions[statusDescriptionKey(status, label)] || i18n.statusDescriptions.pending;
    return `
      <section class="rsv-submitted-status__summary" aria-labelledby="rsv-submitted-status-summary-title">
        <h2 class="rsv-submitted-status__summary-title" id="rsv-submitted-status-summary-title">${escapeHtml(section.heading)}</h2>
        ${section.body.map(renderParagraph).join('')}
      </section>
    `;
  }

  function formatVisit(start, visit) {
    var text = formatJst(start);
    if (!visit || !visit.reservationEndAt || !Number.isFinite(visit.durationMinutes)) return text;
    var end = new Date(visit.reservationEndAt);
    if (!Number.isFinite(+end)) return text;
    var endText = new Date(+end + 9 * 3600000).toISOString().slice(11,16);
    var h = Math.floor(visit.durationMinutes / 60), m = visit.durationMinutes % 60;
    var duration = isEnglish ? [h ? h + 'h' : '', m ? m + 'm' : ''].filter(Boolean).join(' ')
      : (h ? h + '時間' : '') + (m ? m + '分' : '');
    return text + (isEnglish ? '–' : '〜') + endText + (isEnglish ? ' / Duration ' : '／利用時間') + duration
      + (visit.shortenedForClosing ? (isEnglish ? ' (shortened to closing time)' : '（閉店に合わせて短縮）') : '');
  }

  function buildRows(reservation, status) {
    const requestedStore = pickFirst(
      reservation.requestedStoreLabel,
      reservation.requestedStore,
      reservation.originalStore,
      reservation.submittedStore,
      reservation.store
    );
    const confirmedStore = pickFirst(
      reservation.confirmedStoreLabel,
      reservation.assignedStore,
      reservation.confirmedStore,
      reservation.finalStore,
      reservation.customerStore,
      reservation.store
    );
    const confirmedAt = pickFirst(
      reservation.reservationStartAt,
      reservation.trueDate,
      reservation.rsvdate,
      reservation.calendarStartAt
    );
    const baseRows = [
      [i18n.labels.reservationId, reservation.reservationId || reservation.id || rid],
      [i18n.labels.name, reservation.name],
      [i18n.labels.people, reservation.numperson || reservation.peopleCount]
    ];
    const requestRows = [
      [i18n.labels.menu, reservation.menu],
      [i18n.labels.option, reservation.option],
      [i18n.labels.requestedStore, requestedStore],
      [i18n.labels.first, formatVisit(reservation.schedule1, reservation.requestedVisit1)],
      [i18n.labels.second, hasValue(reservation.schedule2) ? formatVisit(reservation.schedule2, reservation.requestedVisit2) : i18n.notSelected]
    ];
    const rows = status === 'confirmed'
      ? baseRows.concat([
        [i18n.labels.confirmedStore, confirmedStore],
        [i18n.labels.confirmedAt, formatVisit(confirmedAt, reservation)]
      ], requestRows)
      : baseRows.concat(requestRows);

    return {
      requestedStore,
      confirmedStore,
      isStoreTransfer: reservation.isStoreTransfer === true
        || reservation.isAltStore === true
        || reservation.createdByAlternateStore === true
        || (normalizeStore(requestedStore) && normalizeStore(confirmedStore) && normalizeStore(requestedStore) !== normalizeStore(confirmedStore)),
      rows
    };
  }

  function shouldShowCheckButton(status) {
    return Boolean(rid && token) && status !== 'confirmed' && status !== 'cancelled';
  }

  function renderLastChecked() {
    if (!lastCheckedAt) return '';
    return `<p class="rsv-submitted-status__last-checked">${escapeHtml(i18n.lastChecked)}: ${escapeHtml(formatJst(lastCheckedAt))}</p>`;
  }

  function renderCheckButton(status, subtle) {
    if (!shouldShowCheckButton(status)) return '';
    const buttonText = isFetching ? i18n.checking : i18n.checkLatest;
    return `
      <div class="rsv-submitted-status__actions">
        <button type="button" class="btn rsv-submitted-status__check-btn${subtle ? ' is-subtle' : ''}" id="rsv-submitted-check-latest"${isFetching ? ' disabled' : ''}>${escapeHtml(buttonText)}</button>
        ${renderLastChecked()}
        ${latestError ? `<p class="rsv-submitted-status__error">${escapeHtml(latestError)}</p>` : ''}
      </div>
    `;
  }

  function confirmedStoreKey(store) {
    const normalized = normalizeStore(store);
    if (/封灯|futo/.test(normalized)) return 'futo';
    if (/自由丁|jiyucho/.test(normalized)) return 'jiyucho';
    return '';
  }

  function renderConfirmedGuideItem(item) {
    if (item === 'space') return '<div class="rsv-submitted-status__guide-space" aria-hidden="true"></div>';
    if (item.heading) return `<h3 class="rsv-submitted-status__guide-heading">${escapeHtml(item.heading)}</h3>`;
    return renderParagraph(item);
  }

  function renderConfirmedGuide(status, confirmedStore) {
    if (status !== 'confirmed') return '';
    const storeKey = confirmedStoreKey(confirmedStore);
    if (!storeKey) return '';
    const guideTitle = isEnglish ? 'Before your visit' : '【ご来店前のご案内】';
    const paymentText = isEnglish
      ? (storeKey === 'futo'
        ? 'Payment can be made by cash, credit card, PayPay, or transportation IC cards.'
        : 'Payment can be made by cash, credit card, or PayPay.')
      : (storeKey === 'futo'
        ? '・お支払い方法は、現金・クレジットカード・PayPay・交通系ICがご利用頂けます。'
        : '・お支払い方法は、現金・クレジットカード・PayPayがご利用頂けます。');
    const staffName = isEnglish
      ? (storeKey === 'futo' ? 'FUTO staff' : 'JIYUCHO staff')
      : (storeKey === 'futo' ? '封灯スタッフ一同' : '自由丁スタッフ一同');
    const storeInfo = isEnglish
      ? (storeKey === 'futo'
        ? [
          'A poetic cafe where you can send a letter to your future self: FUTO',
          [{ text: 'Website: https://jiyucho.tokyo/pages/futo/', href: 'https://jiyucho.tokyo/pages/futo/' }],
          [{ text: 'Google Map: https://maps.app.goo.gl/e6VmLnyxGGigFYGYA', href: 'https://maps.app.goo.gl/e6VmLnyxGGigFYGYA' }],
          'Address: Petit Doll Kuramae 101, 3-15-4 Kuramae, Taito-ku, Tokyo',
          '1 minute walk from Exit A5 of Kuramae Station on the Toei Oedo Line',
          'FUTO TEL: 070-8957-1727'
        ]
        : [
          'A shop where you can send a letter to your future self: JIYUCHO',
          'Address: 4-11-2 Kuramae, Taito-ku, Tokyo',
          '3 minute walk from Exits A0, A2, or A4 of Kuramae Station on the Toei Asakusa Line',
          'JIYUCHO TEL: 070-9135-7383',
          [{ text: 'Website: https://jiyucho.tokyo/', href: 'https://jiyucho.tokyo/' }],
          [{ text: 'Google Map: https://maps.app.goo.gl/Yqgv4YV6dnv72eew8', href: 'https://maps.app.goo.gl/Yqgv4YV6dnv72eew8' }]
        ])
      : (storeKey === 'futo'
        ? [
          '未来の自分へ手紙が送れるお店',
          '詩的喫茶『封灯』',
          [{ text: 'WEBサイト：https://jiyucho.tokyo/pages/futo/', href: 'https://jiyucho.tokyo/pages/futo/' }],
          [{ text: 'Google Map：https://maps.app.goo.gl/e6VmLnyxGGigFYGYA', href: 'https://maps.app.goo.gl/e6VmLnyxGGigFYGYA' }],
          '住所：台東区蔵前3-15-4 プチドール蔵前 101',
          '（都営大江戸線「蔵前駅」A5出口より徒歩1分）',
          '封灯TEL：070-8957-1727'
        ]
        : [
          '未来の自分へ手紙が送れるお店『自由丁』',
          '住所：台東区蔵前4-11-2',
          '（都営浅草線「蔵前駅」A0 A2 A4出口より徒歩3分）',
          '自由丁TEL：070-9135-7383',
          [{ text: 'WEBサイト：https://jiyucho.tokyo/', href: 'https://jiyucho.tokyo/' }],
          [{ text: 'Google Map：https://maps.app.goo.gl/Yqgv4YV6dnv72eew8', href: 'https://maps.app.goo.gl/Yqgv4YV6dnv72eew8' }]
        ]);
    const items = isEnglish
      ? [
        'We strive to create a calm space where each guest can spend time slowly reflecting on themselves and their thoughts.',
        'To help everyone enjoy their time comfortably, please refrain from speaking so loudly that it may disturb others, and we kindly ask for your warm consideration toward other guests and staff in the shop.',
        paymentText,
        { heading: 'Cancellation Policy' },
        'If we do not hear from you and more than 15 minutes have passed since your reservation start time, your reservation may be automatically cancelled.',
        'Even on the day of your visit, we will do our best to accommodate time changes where possible, so please contact us if your plans change.',
        'If you wish to cancel your reservation, please do so by 6:00 PM on the day before your scheduled visit.',
        [
          'For some menu items, a cancellation fee may be charged if you cancel after 6:00 PM on the day before your visit. Please see the following page for details: ',
          { text: 'https://jiyucho.tokyo/pages/cancelreservation', href: 'https://jiyucho.tokyo/pages/cancelreservation' }
        ],
        { heading: 'About the Connecting Bookshelf' },
        'Inside the shop, we also have an exchange-based bookshelf called the Connecting Bookshelf. All books on the shelf were left by visitors to JIYUCHO, and each book includes a small letter from its previous owner. If you bring a book with you, you can exchange it for one from the shelf. We hope you enjoy it during your visit. (Book exchange fee: 550 yen per book)',
        'Please take care on your way here.',
        'We look forward to welcoming you.',
        staffName,
        'space',
        '------------',
        { heading: 'Store Information' },
        ...storeInfo
      ]
      : [
        '・当店はご利用頂く方お一人お一人に、ゆったりご自身のことを考えたり思いを馳せる時間を過ごして頂けるよう、日々運営に努めております。',
        '皆さまに心地よくお過ごしいただくために、恐れ入りますが他の方への迷惑になる程の大きな声でのお喋りはお控えいただき、店内におります他の方々(ご利用中のお客様、業務中のスタッフ)への温かいご配慮を頂けますと幸いです。',
        paymentText,
        { heading: '【キャンセルについて】' },
        '・ご連絡を頂かないまま予約開始時刻から15分を過ぎた場合は自動的にご予約キャンセルとさせて頂く場合がございます。',
        '当日でも可能な限り時間変更は承りますので、ご都合が変わられた場合はご一報頂けますと幸いです！',
        '・ご予約のキャンセルをご希望の場合は、ご来店予定日の前日18時までにお願いいたします。',
        [
          '・一部メニューにつきましては、前日18時以降にキャンセルされた場合、キャンセル料を頂戴しております。詳細は下記リンクをご覧いただけますと幸いです。',
          ' ',
          { text: 'https://jiyucho.tokyo/pages/cancelreservation', href: 'https://jiyucho.tokyo/pages/cancelreservation' }
        ],
        { heading: '【店内「繋がる本棚」について】' },
        'また、店内には交換制の本棚「繋がる本棚」もございます。本棚に置かれた本は、全て自由丁を訪れた方が置いていってくださった本で、本には、元の持ち主の方からの小さなお手紙が添えられています。ご来店の際に本をお持ち頂ければ、本棚の本と交換して頂くことが出来ますので、もしよろしければ合わせてお楽しみください。(本の交換代：550円/一冊)',
        'それでは、当日はお気をつけてお越しくださいませ。',
        '心よりお待ち致しております！',
        staffName,
        'space',
        '------------',
        { heading: '【店舗情報】' },
        ...storeInfo
      ];
    return `
      <section class="rsv-submitted-status__guide" aria-labelledby="rsv-submitted-status-guide-title">
        <h2 class="rsv-submitted-status__guide-title" id="rsv-submitted-status-guide-title">${escapeHtml(guideTitle)}</h2>
        ${items.map(renderConfirmedGuideItem).join('')}
      </section>
    `;
  }

  function updateConfirmedGuide(status, confirmedStore) {
    const guide = document.getElementById('rsv-submitted-confirmed-guide');
    if (!guide) return;
    guide.innerHTML = renderConfirmedGuide(status, confirmedStore);
  }

  function buildStatusPageUrl(reservation) {
    const reservationId = pickFirst(reservation.reservationId, reservation.id, rid);
    const params = new URLSearchParams();
    if (hasValue(reservationId)) params.set('reservationId', reservationId);
    const query = params.toString();
    return query ? `${statusPagePath}?${query}` : statusPagePath;
  }

  function getReservationEmail(reservation) {
    return pickFirst(
      reservation.email,
      reservation.customerEmail,
      reservation.contactEmail,
      reservation.emailAddress,
      reservation.mail
    );
  }

  function attachStatusPagePrefillHandler(reservation) {
    const link = document.querySelector('.rsv-submitted-status__change-link');
    if (!link || !reservation) return;
    link.addEventListener('click', function() {
      try {
        const reservationId = pickFirst(reservation.reservationId, reservation.id, rid);
        const email = getReservationEmail(reservation);
        if (!hasValue(reservationId) || !hasValue(email) || !window.localStorage) return;
        window.localStorage.setItem(`rsvStatusPrefill:${reservationId}`, JSON.stringify({
          email,
          savedAt: Date.now()
        }));
      } catch (e) {}
    });
  }

  function attachCheckHandler() {
    const btn = document.getElementById('rsv-submitted-check-latest');
    if (!btn) return;
    btn.addEventListener('click', function() {
      loadReservation({ refresh: true });
    });
  }

  function renderReservation(reservation) {
    const status = resolveDisplayStatus(reservation);
    currentReservation = reservation;
    currentStatus = status;
    const label = statusLabel(reservation, status);
    const note = !isEnglish && reservation.displayStatusNote ? reservation.displayStatusNote : '';
    const built = buildRows(reservation, status);
    const detailsTitle = status === 'confirmed' ? i18n.confirmedDetailsTitle : i18n.requestDetailsTitle;
    const rowsHtml = built.rows
      .filter(([, value]) => hasValue(value))
      .map(([labelText, value]) => `
        <div class="rsv-submitted-status__row">
          <dt>${escapeHtml(labelText)}</dt>
          <dd>${escapeHtml(safe(value))}</dd>
        </div>
      `).join('');
    const transferHtml = built.isStoreTransfer && status !== 'cancelled'
      ? `<p class="rsv-submitted-status__transfer">${escapeHtml(reservation.tentativeReasonLabel || reservation.transferNote || i18n.transferNote)}</p>`
      : '';
    const notConfirmedHtml = status === 'pending' || status === 'tentative' || status === 'unknown' || status === 'requires_action'
      ? `<p class="rsv-submitted-status__note">${escapeHtml(i18n.notConfirmedNote)}</p>`
      : '';
    const checkHtml = renderCheckButton(status, status !== 'pending' && status !== 'tentative');
    const changeCancelUrl = buildStatusPageUrl(reservation);

    const html = `
      ${renderStatusDescription(status, label)}
      <article class="rsv-submitted-status__card">
        <div class="rsv-submitted-status__status">
          <p>${escapeHtml(i18n.statusTitle)}</p>
          <strong data-status="${escapeHtml(status)}">${escapeHtml(label)}</strong>
          ${note ? `<span>${escapeHtml(note)}</span>` : ''}
        </div>
        ${notConfirmedHtml}
        ${checkHtml}
        ${transferHtml}
        <h2 class="rsv-submitted-status__details-title">${escapeHtml(detailsTitle)}</h2>
        <dl class="rsv-submitted-status__details">${rowsHtml}</dl>
        <a class="btn rsv-submitted-status__change-link" href="${escapeHtml(changeCancelUrl)}" target="_blank" rel="noopener">${escapeHtml(i18n.changeCancel)}</a>
      </article>
    `;

    const body = getBody();
    if (body) {
      body.innerHTML = html;
      attachCheckHandler();
      attachStatusPagePrefillHandler(reservation);
      updateConfirmedGuide(status, built.confirmedStore);
    } else {
      renderShell(html);
      attachCheckHandler();
      attachStatusPagePrefillHandler(reservation);
      updateConfirmedGuide(status, built.confirmedStore);
    }
  }

  function setCheckButtonState(text, disabled) {
    const btn = document.getElementById('rsv-submitted-check-latest');
    if (!btn) return;
    btn.textContent = text;
    btn.disabled = disabled;
  }

  function startCooldown(ms) {
    const btn = document.getElementById('rsv-submitted-check-latest');
    if (!btn) return;
    window.clearTimeout(cooldownTimer);
    setCheckButtonState(i18n.wait, true);
    cooldownTimer = window.setTimeout(function() {
      if (currentReservation) renderReservation(currentReservation);
    }, ms);
  }

  async function loadReservation(options) {
    const isRefresh = Boolean(options && options.refresh);
    if (!rid || !token) {
      renderFallback();
      return;
    }
    if (isFetching) return;

    isFetching = true;
    latestError = '';

    if (isRefresh) {
      setCheckButtonState(i18n.checking, true);
    } else {
      renderShell(`<p class="rsv-submitted-status__loading">${escapeHtml(i18n.loading)}</p>`);
    }

    try {
      const res = await fetch(ENDPOINT, {
        method: 'POST',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rid, reservationId: rid, token })
      });
      const json = await res.json().catch(() => null);
      if (!res.ok || !json || json.success === false) throw new Error((json && json.error) || 'status fetch failed');
      const reservation = normalizeReservationResponse(json);
      if (!reservation) throw new Error('reservation missing');
      lastCheckedAt = new Date();
      isFetching = false;
      renderReservation(reservation);
      if (isRefresh && shouldShowCheckButton(currentStatus)) startCooldown(COOLDOWN_MS);
    } catch (e) {
      console.error('[rsv-submitted] public status fetch failed', e);
      isFetching = false;
      latestError = i18n.checkError;
      if (currentReservation) {
        renderReservation(currentReservation);
        startCooldown(ERROR_COOLDOWN_MS);
      } else {
        renderFallback();
      }
    }
  }

  loadReservation();
})(window, document);
